import React, { useState, useRef } from "react";

import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useParams } from 'react-router-dom';
import swal from "sweetalert";
import * as api from '../../../actions/api';
import OrderFormData from './OrderFormData.js';

import { format } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const AddOrder = (props) => {

//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "order";
const FacilityId=localStorage.getItem('FacilityId');
const UserInfo = encryptionService.decryptUserInfo();  
const UserName = UserInfo==0?'': UserInfo[0].name;
  
const [selectedDate, setSelectedDate] = useState(
 // new Date()
 format(new Date(), 'yyyy-MM-dd')
);

const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState('');
const [bCompleted, setbCompleted] = useState("-1");

const [formData, setFormData] = useState({
  OrderDate: selectedDate,
  OrderNo: generatedInvoiceNo,
  OrderingFrom:"",
  OrderTypeId:"",
  bCompleted:-1,
  ManyJsonSave:"",
  "FacilityId":FacilityId,
  OrderBy:"",
  InternalApprover:"",
  ItemGroupId:props.match.params.id, //Get the url send id
});

const [ManyTableData, setManyTableData] = useState( []);


  const handleRDateChange = (date, field) => {
    
    let newDate;
    if(date==null){
     newDate=date;
    }else{
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const [errorObject, setErrorObject] = useState({});
  const saveInFlightRef = useRef(false);

  const { id } = useParams();
  const queryClient = useQueryClient();


  let params={"menukey": "order", "FacilityId":FacilityId, OrderDate: ''};
  const {  data:invoiceNo, refetch } = useQuery([params], api.getOrdInvoiceNo, 
    {onSuccess: (data) => {
      
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData }; 
      fdata["OrderNo"] = data; 
      setFormData(fdata); 

    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0,//1000 * 60 * 60 * 24,
  }
    );

  

  const { isLoading: isSaveMutating, mutate } = useMutation(api.saveOrderInv, {
    onSuccess: (data) => {

      if(data.status==200) {

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      let route = `/${menukey}/edit/${data.id}`;
      props.history.push(route);

      }else{

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    }
  })

  const runSaveOrder = (payload) => {
    if (saveInFlightRef.current) return;
    saveInFlightRef.current = true;
    mutate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
      let data = { ...formData };
      console.log('formData: ', formData);
      data[name] = value;
      setFormData(data);
   
    setErrorObject({ ...errorObject, [name]: null });
  };


  const handleReset = () => {
    setFormData({
      OrderNo: generatedInvoiceNo,
      OrderDate: selectedDate,
      OrderingFrom:"",
      OrderTypeId:"",
      ManyJsonSave:"",
      FacilityId:FacilityId,
      OrderBy:"",
      InternalApprover:"",
      ItemGroupId:props.match.params.id, //Get the url send id
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["OrderDate", "OrderNo","OrderingFrom","OrderTypeId", "OrderBy"]
    let errorData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !']
        isValid = false
      }
    })
    setErrorObject(errorData);
    return isValid
  }

  const handleSubmit = async (e) => {
    console.log("from submit ", formData);
    if (saveInFlightRef.current || isSaveMutating) return;
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      runSaveOrder(fDtat);
    }
  };

  return (
    <>
      <OrderFormData 
      errorObject={errorObject} 
      addProductForm={true} 
      formData={formData} 
      handleChange={handleChange}  
      handleReset={handleReset} 
      handleSubmit={handleSubmit} 
      ManyTableData={ManyTableData} 
      handleRDateChange={handleRDateChange} 
      selectedDate={selectedDate} 
      generatedInvoiceNo={generatedInvoiceNo}
      bCompleted={bCompleted} 
    
      {...props}
      isSubmitting={isSaveMutating}
       />
    </>
  );
};

export default AddOrder;